import { render, staticRenderFns } from "./cateList.vue?vue&type=template&id=35a504cc&scoped=true&"
import script from "./cateList.vue?vue&type=script&lang=js&"
export * from "./cateList.vue?vue&type=script&lang=js&"
import style0 from "./cateList.vue?vue&type=style&index=0&id=35a504cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a504cc",
  null
  
)

export default component.exports